import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { LiteralsState } from '../../reducers/literals.reducer';
import * as selectors from '../../selectors/literals/flows.literals.selectors';

@Injectable({
  providedIn: 'root',
})
export class FlowsLiteralsFacadeService extends FacadeService {
  constructor(public override store: Store<LiteralsState>) {
    super(store);
  }

  // OBSERVABLES
  flowConfiguration$ = this.storeSelect(selectors.getFlowConfiguration);
  flowName$ = this.storeSelect(selectors.getFlowName);
  flowContext$ = this.storeSelect(selectors.getFlowContext);
  activeFlows$ = this.storeSelect(selectors.getActiveFlows);
  deactivatedFlows$ = this.storeSelect(selectors.getDeactivatedFlows);
  markAsActive$ = this.storeSelect(selectors.getMarkAsActive);
  flowCreated$ = this.storeSelect(selectors.getFlowCreated);
  flowUpdated$ = this.storeSelect(selectors.getFlowUpdated);
  createFlow$ = this.storeSelect(selectors.getCreateFlow);
  updateFlow$ = this.storeSelect(selectors.getUpdateFlow);
  sortContextFlow$ = this.storeSelect(selectors.getSortContextFlow);
  sortCreationDate$ = this.storeSelect(selectors.getSortCreationDate);
  sortFlowName$ = this.storeSelect(selectors.getSortFlowName);
  flowConfigurationTitle$ = this.storeSelect(selectors.getFlowConfigurationTitle);
  helpFlowConfiguration$ = this.storeSelect(selectors.getHelpFlowConfiguration);
  contextFlow$ = this.storeSelect(selectors.getContextFlow);
  flowEvent$ = this.storeSelect(selectors.getFlowEvent);
  editFlowEvent$ = this.storeSelect(selectors.getEditFlowEvent);
  jsonFailed$ = this.storeSelect(selectors.getJSONFailed);
  serverError$ = this.storeSelect(selectors.getServerError);
  successfulValidation$ = this.storeSelect(selectors.getSuccessfulValidation);
  editFlow$ = this.storeSelect(selectors.getEditFlow);
  editFlowAdvanced$ = this.storeSelect(selectors.getEditFlowAdvanced);
  missingStart$ = this.storeSelect(selectors.getMissingStart);
  noMatch$ = this.storeSelect(selectors.getNoMatch);
  tableOrder$ = this.storeSelect(selectors.getTableOrder);
  tableFlowID$ = this.storeSelect(selectors.getTableFlowID);
  tableStartDate$ = this.storeSelect(selectors.getTableStartDate);
  tableEndDate$ = this.storeSelect(selectors.getTableEndDate);
  tableActions$ = this.storeSelect(selectors.getTableActions);
  tableSort$ = this.storeSelect(selectors.getTableSort);
  updateConfiguration$ = this.storeSelect(selectors.getUpdateConfiguration);
  configurationSuccessUpdate$ = this.storeSelect(selectors.getConfigurationSuccessUpdate);
  configurationFailedUpdate$ = this.storeSelect(selectors.getConfigurationFailedUpdate);
  flowNamesNoMatch$ = this.storeSelect(selectors.getFlowNamesNoMatch);

  // OBSERVABLE'S VALUES
  get flowConfiguration() {
    return this.storeSnapshot(this.flowConfiguration$);
  }

  get flowContext() {
    return this.storeSnapshot(this.flowContext$);
  }

  get flowName() {
    return this.storeSnapshot(this.flowName$);
  }

  get sortContextFlow() {
    return this.storeSnapshot(this.sortContextFlow$);
  }

  get sortCreationDate() {
    return this.storeSnapshot(this.sortCreationDate$);
  }

  get sortFlowName() {
    return this.storeSnapshot(this.sortFlowName$);
  }

  get jsonFailed() {
    return this.storeSnapshot(this.jsonFailed$);
  }

  get serverError() {
    return this.storeSnapshot(this.serverError$);
  }

  get successfulValidation() {
    return this.storeSnapshot(this.successfulValidation$);
  }

  get flowUpdated() {
    return this.storeSnapshot(this.flowUpdated$);
  }

  get missingStart() {
    return this.storeSnapshot(this.missingStart$);
  }

  get noMatch() {
    return this.storeSnapshot(this.noMatch$);
  }

  get tableOrder() {
    return this.storeSnapshot(this.tableOrder$);
  }

  get tableFlowID() {
    return this.storeSnapshot(this.tableFlowID$);
  }

  get tableStartDate() {
    return this.storeSnapshot(this.tableStartDate$);
  }

  get tableEndDate() {
    return this.storeSnapshot(this.tableEndDate$);
  }

  get tableActions() {
    return this.storeSnapshot(this.tableActions$);
  }

  get tableSort() {
    return this.storeSnapshot(this.tableSort$);
  }

  get configurationSuccessUpdate() {
    return this.storeSnapshot(this.configurationSuccessUpdate$);
  }

  get configurationFailedUpdate() {
    return this.storeSnapshot(this.configurationFailedUpdate$);
  }

  get flowNamesNoMatch() {
    return this.storeSnapshot(this.flowNamesNoMatch$);
  }
}
